import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import Box from "ds/components/Box";
import Badge from "ds/components/Badge";
import TableCellText from "ds/components/Table/Row/CellText";
import Link from "ds/components/Link";
import useTypedContext from "hooks/useTypedContext";
import { StackRoleBindingView } from "shared/Stack/Roles/types";
import { SpacesContext } from "views/Account/SpacesProvider";
import { AnalyticsPageStack } from "hooks/useAnalytics/pages/stack";

const StackRolesNameCell = ({
  item: roleBinding,
  ...cellProps
}: TableSimpleCellProps<StackRoleBindingView>) => {
  const { hasManageableSpaces } = useTypedContext(SpacesContext);

  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <Box align="center" fullWidth gap="large">
        {hasManageableSpaces ? (
          <Link
            href={`/settings/role/${roleBinding.role.id}`}
            target="_blank"
            variant="secondary"
            analyticsPage={AnalyticsPageStack.StackSettingsRoles}
            analyticsTitle="Navigated to role settings"
          >
            {roleBinding.role.name}
          </Link>
        ) : (
          <TableCellText>{roleBinding.role.name}</TableCellText>
        )}

        {roleBinding?.role?.isSystem && <Badge type="strong" variant="blue" text="SYSTEM" />}
      </Box>
    </TableSimpleCell>
  );
};

export default StackRolesNameCell;
